import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useLanguage } from "@/i18n";
import { Reveal } from "@/components/Reveal";
import ArticleCard from "@/components/ArticleCard";
import { api } from "@/lib/api";

export default function SezioneDinamica() {
  const { slug } = useParams();
  const { lang, t } = useLanguage();
  const [section, setSection] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [sectionArticles, setSectionArticles] = useState([]);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    api
      .get(`/sections/${slug}`)
      .then((res) => setSection(res.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
    api
      .get("/articles", { params: { section: slug } })
      .then((res) => setSectionArticles(res.data))
      .catch(() => setSectionArticles([]));
  }, [slug]);

  const title = (lang === "en" && section?.title_en) || section?.title;
  const subtitle = (lang === "en" && section?.subtitle_en) || section?.subtitle;
  const body = (lang === "en" && section?.body_en) || section?.body;
  const paragraphs = (body || "").split("\n\n").filter(Boolean);

  useEffect(() => {
    if (!section) return;
    document.title = `${title} — Dott. Angilè`;
  }, [section, title]);

  return (
    <div data-testid="sezione-dinamica-page" className="pt-24 sm:pt-32 min-h-screen">
      <div className="container-editorial max-w-3xl pb-20 sm:pb-28">
        {loading && <p className="mt-10 text-sm font-light text-slate-500">{t.articles.loading}</p>}
        {notFound && <p className="mt-10 font-serif text-2xl text-slate-700">{t.sectionPage.notFound}</p>}
        {section && (
          <article>
            <Reveal>
              {subtitle && <p className="eyebrow">{subtitle}</p>}
              <h1 className="mt-4 font-serif text-4xl sm:text-5xl font-light leading-[1.12] text-slate-900 tracking-tight">
                {title}
              </h1>
            </Reveal>
            {section.image && (
              <Reveal delay={0.1}>
                <div className="mt-10 overflow-hidden">
                  <img src={section.image} alt={title} className="w-full h-72 sm:h-96 object-cover" />
                </div>
              </Reveal>
            )}
            {paragraphs.length > 0 && (
              <Reveal delay={0.15}>
                <div className="article-body mt-12">
                  {paragraphs.map((p, i) => (
                    <p key={i}>{p}</p>
                  ))}
                </div>
              </Reveal>
            )}
            {sectionArticles.length > 0 && (
              <div className="mt-16 border-t border-slate-200 pt-10" data-testid="section-articles-container">
                <p className="eyebrow">{t.articles.eyebrow}</p>
                <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {sectionArticles.map((a) => (
                    <ArticleCard key={a.slug} article={a} testid={`section-article-${a.slug}`} showViews />
                  ))}
                </div>
              </div>
            )}
          </article>
        )}
      </div>
    </div>
  );
}
